import { Typography } from '@mui/material'
import React from 'react'
import usageMeteringNoData from '../../../common/images/usageMeteringNoData.png'
import { useStyles } from './UsageMeteringNoDataState.styles'

export const UsageMeteringNoDataState: React.FC<{
  text: string
  fullHeight?: boolean
}> = ({ text, fullHeight = false }) => {
  const { classes } = useStyles({ fullHeight })
  return (
    <div
      data-testid="usage-metering-no-data-state"
      className={classes.mainContainer}
    >
      <img
        className={classes.noDataImage}
        src={usageMeteringNoData}
        alt={'no-data-state'}
      />
      <Typography className={classes.description}>{text}</Typography>
    </div>
  )
}
